import MaterialTypeEnum from "../../enums/MaterialTypeEnum";
import ColorMaterial from "./ColorMaterial";
import Material from "./Material";
import SvgMaterial from "./SvgMaterial";
import TextureMaterial from "./TextureMaterial";

export default class MaterialFactory {
    visualizerApiUrl: URL;

    constructor(visualizerApiUrl: URL) {
        this.visualizerApiUrl = visualizerApiUrl;
    }

    materialFromJson(input : {materialType: string}) : Material {
    
    const materialTypeEnumValue = (MaterialTypeEnum as any)[input.materialType] as MaterialTypeEnum;
    switch (materialTypeEnumValue) {
        case MaterialTypeEnum.ColorMaterial:
            return ColorMaterial.fromJSON(input);

        case MaterialTypeEnum.SvgMaterial:
        
            const svgMaterial = SvgMaterial.fromJSON(input);

            svgMaterial.url = new URL(svgMaterial.url, this.visualizerApiUrl).href; // Prepend visualizerApiUrl to the url so url is ready to use
            return svgMaterial;

        case MaterialTypeEnum.TextureMaterial:
            return TextureMaterial.fromJSON(input);
            
        default:
            throw "Not supported material type";
    }
    }
};